// extracted by css-extract-rspack-plugin
export default {"viewDetails":"RDkM2t_7AQC0YEwa","divider":"a8RhGwfGkkAjXgMm","chartWrapper":"BkeLswdPZKAt24W1"};